import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { restoreTimerState } from '../helpers/timerCloudStorage';

let hasRestored = false;

export const TimerRestoreHandler = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    if (hasRestored) return;
    
    const checkAndRestoreTimer = async () => {
      try {
        const savedState = await restoreTimerState();
        if (savedState && savedState.questId && !hasRestored) {
          hasRestored = true;
          navigate(`/focus-mode/${savedState.questId}`);
        }
      } catch (error) {
        console.error('Failed to restore timer state on app launch:', error);
      }
    };

    checkAndRestoreTimer();
  }, []);

  return null;
};